import { FC } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import { ShapeWithClassName } from '@app/constants';

import './EmptyRecordsMessage.scss';

interface EmptyRecordsMessageProps {
  icon: IconProp;
  message: string;
  testId?: string;
}

export const EmptyRecordsMessage: FC<
  ShapeWithClassName<EmptyRecordsMessageProps>
> = ({ icon, message, className, testId = 'empty-state', children }) => {
  const cnBem = createBemBlockBuilder(['emptyRecordsMessage', className]);

  return (
    <div className={cnBem()} data-auto={testId}>
      <FontAwesomeIcon icon={icon} className={cnBem('__icon')} />
      {message}
      {children}
    </div>
  );
};
